import React from 'react'
import BlogEntry from "./BlogEntry";

const BlogArea = ({blogEntries=[]}) => {
  return (
      <section className="blog-area pt-115 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-4">
                <h2>Latest <span>News</span></h2>
              </div>
            </div>
          </div>
          <div className="row">
            {blogEntries?.map((entry, index) => <BlogEntry key={index} entry={entry}/>)}
          </div>
        </div>
      </section>
  )
}

export default BlogArea
